<template>
  <div>
    <a-page-header
      :breadcrumb="{ props: { routes:[{path: '/',breadcrumbName: '首页'}
      ,{path:'/goods',breadcrumbName:'商品列表'}
      ,{path: `/goods/${goodsId}$`,breadcrumbName: '商品信息'}
      ]}}"
      style="border: 1px solid rgb(235,237,240);background: #ffffff"
      title='商品信息'/>
    <div style="position: relative">
      <a-menu :defaultSelectedKeys="['info']" mode="horizontal">
        <a-menu-item key="info">
          <a-icon type="mail"/>
          商品信息
        </a-menu-item>
        <a-menu-item
          key="sku"
          :disabled="!goodsId"
          @click="() => {this.$router.push(`/goods/${goodsId}/skus`)}">
          <a-icon type="appstore"/>
          SKU
        </a-menu-item>
      </a-menu>
      <a-space style="position: absolute;right: 8px; top:8px">
        <a-button v-if="!goodsId" type="primary" @click="onAdd">创建</a-button>
        <a-button v-if="goodsId" type="info" @click="preSell">预售</a-button>
        <a-button v-if="goodsId" type="success" @click="inSell">上架</a-button>
        <a-button v-if="goodsId" type="danger" @click="off">下架</a-button>
        <a-button v-if="goodsId" type="primary" @click="onSave">保存</a-button>
        <a-button v-if="goodsId" type="primary" @click="onUpdate">更新</a-button>
        <a-button @click="onCancel">返回</a-button>
      </a-space>
    </div>
    <div style="margin: 16px">
      <a-spin :spinning="form.loading">
        <a-form-model ref="form" :model="form.data" :rules="form.rules" style="margin-top: 20px">
          <a-row :gutter="20">
            <a-col :span="18">
              <a-card :bordered="false" title="基础信息">
                <a-form-model-item label="商品名称" prop="name">
                  <a-input v-model="form.data.name" auto-focus/>
                </a-form-model-item>
                <a-form-model-item label="商品英文名" prop="nameEn">
                  <a-input v-model="form.data.nameEn"/>
                </a-form-model-item>
                <a-form-model-item label="编码">
                  <a-input v-model="form.data.code"/>
                </a-form-model-item>
              </a-card>
              <a-card :bordered="false" style="margin-top: 20px" title="图片">
                <a-form-model-item label="封面(160*160)">
                  <div class="a-input">
                    <simple-uploader
                      v-model="form.data.coverPath"
                      :imageUrl="form.data.coverPath"
                      :options="coverOptions"
                      avatarTextTop=""
                      avatarTextBottom=""/>
                  </div>
                </a-form-model-item>
                <a-form-model-item label="图集(160*160)">
                  <div class="a-input">
                    <multi-uploader
                      v-model="form.data.images"
                      :options="imagesOptions"/>
                  </div>
                </a-form-model-item>
              </a-card>
              <a-card title="商品尺寸描述" :bordered="false" style="margin-top: 20px">
                <a-form-model-item label="尺寸字典">
                  <a-select v-model="form.data.sizeImage" placeholder="请选择" allowClear>
                    <a-select-option
                      v-for="item in size.data"
                      :key="item.id"
                      :title="item.code"
                      :value="item.code"
                    >
                      {{ item.code }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-card>
              <a-card :bordered="false" style="margin-top: 20px" title="商品描述">
                <a-form-model-item label="商品描述" prop="description">
                  <a-textarea
                    v-model="form.data.description"
                    :autosize="{minRows: 10}"/>
                </a-form-model-item>
                <a-form-model-item label="商品描述英文" prop="descriptionEn">
                  <a-textarea
                    v-model="form.data.descriptionEn"
                    :autosize="{minRows: 10}"/>
                </a-form-model-item>
              </a-card>
            </a-col>
            <a-col :span="6">
              <a-card :bordered="false" title="相关信息">
                <a-form-model-item label="系列" prop="seriesId" required>
                  <a-select v-model="form.data.seriesId" placeholder="请选择">
                    <a-select-option
                      v-for="item in series.data"
                      :key="item.id"
                      :title="item.name"
                      :value="item.id"
                      @click="queryCategory(item.id)"
                    >
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item label="系列下的分类" prop="categoryId" required>
                  <a-select v-model="form.data.categoryId" :allowClear="true" placeholder="先选择系列，再选择分类">
                    <a-select-option
                      v-for="item in category.data"
                      :key="item.id"
                      :title="item.name"
                      :value="item.id"
                      @click="queryCategoryName(item.name)"
                    >
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-card>
              <a-card :bordered="false" style="margin-top: 20px">
                <span slot="title">
                  <a-icon style="padding-right: 10px" type="account-book"/>商品状态
                </span>
                <a-form-model-item
                  label="是否上架"
                  prop="status"
                  required>
                  <dict-select
                    v-model="form.data.status"
                    dict-code="GOODS_STATUS"/>
                </a-form-model-item>
                <a-form-model-item
                  v-if="form.data.status === 'PRESELL'"
                  label="上架时间"
                  prop="sellStartAt"
                  required>
                  <a-date-picker
                    v-model="form.data.sellStartAt"
                    :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                    placeholder=""
                    style="width: 100%"
                    type="datetime"
                    value-format="YYYY-MM-DDTHH:mm:ss">
                  </a-date-picker>
                </a-form-model-item>
                <!--                <a-form-model-item-->
                <!--                  v-if="form.data.status==='PRESELL'"-->
                <!--                  label="下架时间"-->
                <!--                  requird>-->
                <!--                  <a-date-picker-->
                <!--                    v-model="form.data.sellEndAt"-->
                <!--                    :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"-->
                <!--                    placeholder=""-->
                <!--                    style="width: 100%"-->
                <!--                    type="datetime"-->
                <!--                    value-format="YYYY-MM-DDTHH:mm:ss">-->
                <!--                  </a-date-picker>-->
                <!--                </a-form-model-item>-->
              </a-card>

              <a-card :bordered="false" style="margin-top: 20px" title="销售信息">
                <a-form-model-item label="价格" prop="price">
                  <a-input-number v-model="form.data.price" :min="0"/>
                </a-form-model-item>
                <a-form-model-item label="标价" prop="listPrice" required>
                  <a-input-number v-model="form.data.listPrice" :min="0"/>
                </a-form-model-item>
                <a-form-model-item label="上一次价格" prop="previousPrice">
                  <a-input-number v-model="form.data.previousPrice" :min="0"/>
                </a-form-model-item>
                <a-form-model-item label="开始价格" prop="startPrice" required>
                  <a-input-number v-model="form.data.startPrice" :min="0"/>
                </a-form-model-item>
                <a-form-model-item label="结束价格" prop="endPrice" required>
                  <a-input-number v-model="form.data.endPrice" :min="0"/>
                </a-form-model-item>
                <a-form-model-item label="是否限购" prop="isLimited" required>
                  <dict-select
                    v-model="form.data.isLimited"
                    dict-code="SIMPLE_STATUS"/>
                </a-form-model-item>
                <a-form-model-item label="旺铺管家收款" prop="isSpecialSettlement" required>
                  <dict-select
                    v-model="form.data.isSpecialSettlement"
                    dict-code="SIMPLE_STATUS"/>
                </a-form-model-item>
                <a-form-model-item label="限购数量">
                  <a-input-number
                    v-model="form.data.limitedQuantity"
                    :disabled="form.data.isLimited==='NO'"/>
                </a-form-model-item>
                <a-form-model-item label="是vip?" prop="isVip" required>
                  <dict-select
                    v-model="form.data.isVip"
                    dict-code="SIMPLE_STATUS"/>
                </a-form-model-item>
                <a-form-model-item label="是否是新品" prop="isNew" required>
                  <dict-select
                    v-model="form.data.isNew"
                    dict-code="SIMPLE_STATUS"/>
                </a-form-model-item>
              </a-card>
            </a-col>
          </a-row>
        </a-form-model>
      </a-spin>
    </div>       <!-- </a-card> -->

    <a-modal
      :footer="null"
      append-to-body
      :title="$t('PREVIEW')||'预览'"
      v-model="video.visible">
      <video
        v-if="video.visible"
        ref="video"
        webkit-playsinline="true"
        playsinline="true"
        x-webkit-airplay="true"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        x5-video-orientation="portraint"
        style="width: 100%;height: auto"
        autoplay
        preload="auto"
        muted="true"
        :src="form.data.inspirationVideo"
      >您的浏览器不支持HTML5
      </video>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment';
import { _addGoods, _queryGoodsById, _updateGoods, } from '@/api/goodsApi';
import { _queryCategoryBySeriesId, _queryGoodsSeriess, } from '@/api/goodsSeriesApi';
import { _getCategoryByVipSeries, _queryGoodsCategories, } from '@/api/goodsCategoryApi';
import { _queryAppInfoByType } from '@/api/appInfoApi';
import DictSelect from '../../../components/DictSelect.vue';
import MultiUploader from '../../../components/MultiUploaderOld.vue';
import SimpleUploader from '../../../components/SimpleUploader.vue';
import CropperUploader from '@/components/CropperUploader.vue';

async function getGoods() {
  const result = await _queryGoodsById(this.goodsId);
  if (result) {
    this.form.data.name = result.name;
    this.form.data.nameEn = result.nameEn;
    this.form.data.code = result.code;
    this.form.data.categoryId = result.categoryId;
    this.form.data.seriesId = result.seriesId;
    this.form.data.coverPath = result.coverPath;
    this.form.data.isLimited = result.isLimited;
    this.form.data.limitedQuantity = result.limitedQuantity;
    this.form.data.status = result.status;
    this.form.data.isPresell = result.isPresell;
    this.form.data.sellStartAt = result.sellStartAt;
    this.form.data.sellEndAt = result.sellEndAt;
    this.form.data.price = result.price;
    this.form.data.sizeImage = result.sizeImage;
    this.form.data.detail = result.detail;
    this.form.data.listPrice = result.listPrice;
    this.form.data.previousPrice = result.previousPrice;
    this.form.data.description = result.description;
    this.form.data.descriptionEn = result.descriptionEn;
    this.form.data.salesQuantity = result.salesQuantity;
    this.form.data.images = result.images ? result.images.split('|') : [];
    this.form.data.type = result.type;
    this.form.data.inspirationVideo = result.inspirationVideo ? result.inspirationVideo.split(',') : [];
    this.form.data.inspirationImg = result.inspirationImg ? result.inspirationImg.split(',') : [];
    this.form.data.content = result.content;
    this.form.data.isVip = result.isVip;
    this.form.data.isNew = result.isNew;
    this.form.data.videoCover = result.videoCover;
    this.form.data.startPrice = result.startPrice;
    this.form.data.endPrice = result.endPrice;
    // 设为 false
    this.form.loading = false;
    this.categoryName = result.category.name;
    this.form.data.isSpecialSettlement = result.isSpecialSettlement;
  }
}

async function onAdd() {
  if (this.form.data.isVip === 'NO') {
    this.vipCategoryId = null;
    this.vipSeriesId = null;
  } else {
    const { vipCategoryId } = '';
    this.vipSeriesId = '1531903218005708800';
    const vipSeries = _getCategoryByVipSeries(this.form.data.categoryName);
    this.vipCategoryId = vipSeries.id;
  }
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      await _addGoods({
        name: this.form.data.name,
        nameEn: this.form.data.nameEn,
        code: this.form.data.code,
        seriesId: this.form.data.seriesId,
        categoryId: this.form.data.categoryId,
        isLimited: this.form.data.isLimited,
        limitedQuantity: this.form.data.limitedQuantity,
        status: this.form.data.status,
        isPresell: this.form.data.isPresell,
        sellStartAt: this.form.data.sellStartAt,
        sellEndAt: this.form.data.sellEndAt,
        price: this.form.data.price,
        listPrice: this.form.data.listPrice,
        coverPath: this.form.data.coverPath,
        description: this.form.data.description,
        descriptionEn: this.form.data.descriptionEn,
        salesQuantity: this.form.data.salesQuantity,
        images: this.form.data.images.join('|'),
        type: this.form.data.type,
        inspirationImg: this.form.data.inspirationImg.join('|'),
        inspirationVideo: this.form.data.inspirationVideo.join('|'),
        previousPrice: this.form.data.previousPrice,
        content: this.form.data.content,
        isVip: this.form.data.isVip,
        sizeImage: this.form.data.sizeImage,
        videoCover: this.form.data.videoCover,
        vipCategoryId: this.vipCategoryId,
        vipSeriesId: this.vipSeriesId,
        isNew: this.form.data.isNew,
        startPrice: this.form.data.startPrice,
        endPrice: this.form.data.endPrice,
        isSpecialSettlement: this.form.data.isSpecialSettlement,
      });
      this.$message.success('添加成功');
      if (this.onSubmitHandler) {
        this.onSubmitHandler();
        await this.$router.go(-1);
      } else {
        await this.$router.go(-1);
      }
    }
  });
}

function inSell() {
  this.form.data.status = 'IN_SELL';
  this.onUpdate();
}

function preSell() {
  this.form.data.status = 'PRESELL';
  this.onUpdate();
}

function off() {
  this.form.data.status = 'OFF';
  this.onUpdate();
}

async function onUpdate() {
  if (this.form.data.isVip === 'NO') {
    this.vipCategoryId = null;
    this.vipSeriesId = null;
  } else {
    this.vipSeriesId = '1531903218005708800';
    const result1 = await _getCategoryByVipSeries(this.categoryName);
    this.vipCategoryId = result1.id;
  }
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      if (this.form.data.status === 'PRESELL') {
        if (this.form.data.sellEndAt) {
          if (this.form.data.sellStartAt === null || this.form.data.sellStartAt === undefined) {
            this.$message.error('上架时间未设置，检查后重新尝试！');
            return;
          }
          if (moment(this.form.data.sellEndAt).valueOf() < moment(this.form.sellStartAt).valueOf()) {
            this.$message.error('下架时间设置不合理，请检查后再操作');
            return;
          }
        }
        // this.$message.error('未设置上架时间，请检查后操作')
      }
      await _updateGoods(this.goodsId, {
        name: this.form.data.name,
        nameEn: this.form.data.nameEn,
        code: this.form.data.code,
        seriesId: this.form.data.seriesId,
        categoryId: this.form.data.categoryId,
        isLimited: this.form.data.isLimited,
        limitedQuantity: this.form.data.limitedQuantity,
        status: this.form.data.status,
        isPresell: this.form.data.isPresell,
        sellStartAt: this.form.data.sellStartAt,
        sellEndAt: this.form.data.sellEndAt,
        price: this.form.data.price,
        listPrice: this.form.data.listPrice,
        coverPath: this.form.data.coverPath,
        description: this.form.data.description,
        descriptionEn: this.form.data.descriptionEn,
        salesQuantity: this.form.data.salesQuantity,
        images: this.form.data.images.join('|'),
        type: this.form.data.type,
        inspirationImg: this.form.data.inspirationImg.join('|'),
        inspirationVideo: this.form.data.inspirationVideo.join('|'),
        previousPrice: this.form.data.previousPrice,
        content: this.form.data.content,
        isVip: this.form.data.isVip,
        sizeImage: this.form.data.sizeImage,
        videoCover: this.form.data.videoCover,
        vipCategoryId: this.vipCategoryId,
        vipSeriesId: this.vipSeriesId,
        isNew: this.form.data.isNew,
        startPrice: this.form.data.startPrice,
        endPrice: this.form.data.endPrice,
        isSpecialSettlement: this.form.data.isSpecialSettlement,
      });

      this.$message.success('更新成功');
      this.getGoods();
    }
  });
}

async function onSave() {
  if (this.form.data.isVip === 'NO') {
    this.vipCategoryId = null;
    this.vipSeriesId = null;
  } else {
    this.vipSeriesId = '1531903218005708800';
    const result1 = await _getCategoryByVipSeries(this.categoryName);
    this.vipCategoryId = result1.id;
  }
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      if (this.form.data.status === 'PRESELL') {
        if (this.form.data.sellEndAt) {
          if (this.form.data.sellStartAt === null || this.form.data.sellStartAt === undefined) {
            this.$message.error('上架时间未设置，检查后重新尝试！');
            return;
          }
          if (moment(this.form.data.sellEndAt).valueOf() < moment(this.form.sellStartAt).valueOf()) {
            this.$message.error('下架时间设置不合理，请检查后再操作');
            return;
          }
        }
        // this.$message.error('未设置上架时间，请检查后操作')
      }
      await _updateGoods(this.goodsId, {
        name: this.form.data.name,
        nameEn: this.form.data.nameEn,
        code: this.form.data.code,
        seriesId: this.form.data.seriesId,
        categoryId: this.form.data.categoryId,
        isLimited: this.form.data.isLimited,
        limitedQuantity: this.form.data.limitedQuantity,
        status: this.form.data.status,
        isPresell: this.form.data.isPresell,
        sellStartAt: this.form.data.sellStartAt,
        sellEndAt: this.form.data.sellEndAt,
        price: this.form.data.price,
        listPrice: this.form.data.listPrice,
        coverPath: this.form.data.coverPath,
        description: this.form.data.description,
        descriptionEn: this.form.data.descriptionEn,
        salesQuantity: this.form.data.salesQuantity,
        images: this.form.data.images.join('|'),
        type: this.form.data.type,
        inspirationImg: this.form.data.inspirationImg.join('|'),
        inspirationVideo: this.form.data.inspirationVideo.join('|'),
        previousPrice: this.form.data.previousPrice,
        content: this.form.data.content,
        isVip: this.form.data.isVip,
        sizeImage: this.form.data.sizeImage,
        videoCover: this.form.data.videoCover,
        vipCategoryId: this.vipCategoryId,
        vipSeriesId: this.vipSeriesId,
        isNew: this.form.data.isNew,
        startPrice: this.form.data.startPrice,
        endPrice: this.form.data.endPrice,
        isSpecialSettlement: this.form.data.isSpecialSettlement,
      });

      this.$message.success('保存成功');
      this.getGoods();
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  } else {
    this.$router.go(-1);
  }
}

async function queryCategory(seriesId) {
  const result = await _queryCategoryBySeriesId(seriesId);
  this.category.data = result;
}

async function queryCategoryName(name) {
  this.categoryName = name;
}

async function changeCategory(seriesId) {
  const result = await _queryCategoryBySeriesId(seriesId);
  this.category.data = result;
}

function reviewVideo() {
  if (this.form.data.inspirationVideo) {
    this.video.visible = true;
  }
}

export default {
  name: 'GoodsEdit',
  components: {
    // CropperUploader,
    SimpleUploader,
    MultiUploader,
    DictSelect,
  },
  props: {
    goodsId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  data() {
    return {
      vipCategoryId: '',
      vipSeriesId: '',
      categoryName: '',
      video: {
        visible: false,
        url: '',
      },
      category: {
        data: [],
      },
      series: {
        data: [],
      },
      size: {
        data: [],
      },
      imagesOptions: {
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 1000, // 默认生成截图框宽度
        autoCropHeight: 1000, // 默认生成截图框高度
        fixedBox: false, // 是否固定截图框大小 不允许改变
        previewsCircle: false, // 预览图是否是圆形
        multi: true,
        serviceType: 'OSS',
        title: '修改图片',
      },
      coverOptions: {
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 1000, // 默认生成截图框宽度
        autoCropHeight: 1000, // 默认生成截图框高度
        fixedBox: false, // 是否固定截图框大小 不允许改变
        previewsCircle: false, // 预览图是否是圆形
        serviceType: 'OSS',
        title: '修改图片',
      },
      form: {
        loading: false,
        tab: 'IMAGE',
        data: {
          name: '',
          nameEn: '',
          description: '',
          descriptionEn: '',
          code: '',
          isLimited: 'NO',
          limitedQuantity: 0,
          status: 'OFF',
          salesQuantity: 0,
          isPresell: 'NO',
          sellStartAt: `${moment().format('YYYY-MM-DD')}T00:00:00`,
          sellEndAt: `${moment().format('YYYY-MM-DD')}T00:00:00`,
          price: 0,
          previousPrice: 0,
          listPrice: 0,
          type: '',
          categoryId: '',
          seriesId: '',
          content: '',
          coverPath: '',
          images: [],
          inspirationImg: [],
          inspirationVideo: [],
          isVip: 'NO',
          isNew: 'NO',
          sizeImage: '',
          videoCover: '',
          startPrice: '',
          endPrice: '',
          isSpecialSettlement: 'NO',
        },
        title: '',
        rules: {
          name: [{ required: true, trigger: 'blur' }],
          nameEn: [{ required: true, trigger: 'blur' }],
          code: [{ required: true, trigger: 'blur' }],
          isLimited: [{ required: true, trigger: 'blur' }],
          isSpecialSettlement: [{ required: true, trigger: 'blur' }],
          status: [{ required: true, trigger: 'blur' }],
          salesQuantity: [{ required: true, trigger: 'blur' }],
          description: [{ required: true, trigger: 'blur' }],
          isPresell: [{ required: true, trigger: 'blur' }],
          sellStartAt: [{ required: true, trigger: 'blur' },
            {
              type: 'date', min: moment.now(), message: '选择时间必须大于当前', trigger: 'blur',
            }],
          // price: [{ required: true, trigger: 'blur' }],
          listPrice: [{ required: true, trigger: 'blur' }],
          categoryId: [{ required: true, trigger: 'blur' }],
          seriesId: [{ required: true, trigger: 'blur' }],
        },
      },

    };
  },
  methods: {
    moment,
    onAdd,
    onUpdate,
    onSave,
    onCancel,
    getGoods,
    preSell,
    inSell,
    off,
    queryCategory,
    reviewVideo,
    changeCategory,
    queryCategoryName,
  },
  watch: {
    'form.data.price': {
      handler(val) {
        this.form.data.discount = (val / this.form.data.listPrice * 100 / 100).toFixed(2);
      },
    },
    'form.data.listPrice': {
      handler(val) {
        this.form.data.discount = (this.form.data.price / val * 100 / 100).toFixed(2);
      },
    },
  },
  created: async function () { // 异步加载
    const seriesResult = await _queryGoodsSeriess({});
    // this.series.data = seriesResult.content;
    const seriesList = seriesResult.content.filter(item => item.id !== '1531903218005708800');
    this.series.data = seriesList;
    const categoryResult = await _queryGoodsCategories({});
    // this.category.data = categoryResult.content;
    const list = categoryResult.content.filter(item => item.parentId !== '1531903218005708800');
    this.category.data = list;

    const result = await _queryAppInfoByType({});
    this.size.data = result;

    if (this.goodsId) {
      await this.getGoods();
    }
  },
};
</script>

<style scoped>

</style>
